export default {"src":"/_next/static/media/Bank.0aa0e9a1.svg","height":31,"width":39,"blurWidth":0,"blurHeight":0};